module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/skyline-marker-e058086fa6430ba13a231ad01c84008a.svg";